import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";

import rootReducer from "./reducers";
import { tokenMiddleware } from "../middlewares/token_middleware";
import { initializeAuth } from "./actions/auth_actions";

const createAppStore = async () => {
  const store = configureStore({
    reducer: rootReducer,
    middleware: [thunk, tokenMiddleware],
  });

  try {
    await store.dispatch(initializeAuth());
  } catch (error) {
    if (typeof console !== "undefined") {
      console.warn("Auth initialization failed; continuing without it.", error);
    }
  }

  return store;
};

export default createAppStore;
